module.exports = __webpack_public_path__ + "img/nav_logo.2d676ac9.png";